  <template>
    <wgu-module-card v-bind="$attrs" :moduleName="moduleName" class="analysetool-win" v-on:visibility-change="show"
      width=400>

      <v-card flat color="transparent" class="ma-2">
        <v-card-actions>
          <v-row align="center" no-gutters>
          <v-col>
            <v-item-group >
              <v-row>
                <v-item class="mt-4 mr-2">
                  <featurePicker
                    layerId="fvp_waermeplan"
                    @input="parseSelectedFeatures"
                  />
                </v-item>
                <v-item>
                  <v-col>
                      {{$t('analysetool.info')}}
                  </v-col>
                </v-item>
                <br>
              </v-row>
            </v-item-group>
          </v-col>

          <v-col class="fill-height shrink">
            <v-alert v-model="alertVisible" :type="alertType" dismissible>
              {{ alertMessage }}
            </v-alert>
          </v-col>
        </v-row>
        </v-card-actions>

        <div id="chartContainer"  class="mt-8">
        <div v-if="currentLegible">
          <div class="my-6" style="color: #0051a6">
              <img class="mt-2" src="../../static/icon/graph_legend.png" alt="roter-marker" height="50"/>
              <br>
              {{$t('analysetool.legend')}}
           </div>
          <h1>
            {{ city_name }}
          </h1>

          <div v-if="has_kennzahlen">
            <p class="mt-4" > {{$t('analysetool.chartRenewableTitle')}} </p>
            <analysetool-piechart
              id="renewablesChart"
              :title="$t('analysetool.chartRenewableTitle')"
              unit="MWh/a"
              :dataSource="renewablePieData"
              labelColumn="name"
              valueColumn="value"
              :loading="loading"
            />
            <p class="text--secondary ma-8 text-h6">{{ $t('analysetool.total') }} {{total.toLocaleString()}} MWh/a</p>

          <v-divider :thickness="2"></v-divider>
            <p  class="mt-4"> {{$t('analysetool.chartCurrentTitle')}}</p>
            <analysetool-piechart
              id="currentChart"
              unit="MWh/a"
              :dataSource="currentPieData"
              labelColumn="name"
              valueColumn="value"
              :loading="loading"
            />

            <v-divider :thickness="2" class="mt-4"></v-divider>

              <p  class="mt-4"> {{$t('analysetool.chart2045Title')}}</p>
              <analysetool-piechart
                id="futureChart"
                unit="MWh/a"
                :dataSource="futurePieData"
                labelColumn="name"
                valueColumn="value"
                :loading="loading"
              />
            <div >
              <p  class="mt-4"> {{$t('analysetool.energySavingTitle')}}</p>
              <p class="text--secondary ma-8 text-h6"> {{ $t('analysetool.share') }}: {{ this.einsparungProzent }} %</p>
              <p class="text--secondary ma-8 text-h6"> {{ $t('analysetool.absolute') }}: {{ this.einsparungAbsolut.toLocaleString() }} MWh/a</p>
            </div>

            <div >
              <p  class="mt-4"> {{$t('analysetool.energyShareTitle')}}</p>
              <p class="text--secondary ma-8 text-h6">{{ $t('analysetool.hydrogen') }}: {{ this.shareWasserstoff }} %</p>
              <p class="text--secondary ma-8 text-h6">{{ $t('analysetool.biogen') }}: {{ this.shareBiogen }} %</p>
            </div>

            </div>
            <div v-else>
              {{$t('analysetool.noData')}}
            </div>

            <v-divider :thickness="2" class="mt-4"></v-divider>

        </div>
        <div v-else>
              {{$t('analysetool.noSelection')}}
            <p class="mt-2">Symbole:
            <img src="../../static/icon/location_green.svg" alt="roter-marker" height="30"/>
            <img src="../../static/icon/location_check.svg" alt="blauer-marker" height="30"/>
            </p>
      </div>
      </div>
      </v-card>
    </wgu-module-card>
  </template>

<script>
import ModuleCard from '../../../src/components/modulecore/ModuleCard';
import { Mapable } from '../../../src/mixins/Mapable';
import PieChart from './PieChart';
import DataController from './DataController'
import FeaturePicker from '../uicontrols/featurePicker/FeaturePicker';
import dict from '../../static/data/energietraeger_dict.json';

export default {
  name: 'analysetool-win',
  inheritAttrs: false,
  mixins: [Mapable],
  components: {
    'wgu-module-card': ModuleCard,
    'analysetool-piechart': PieChart,
    featurePicker: FeaturePicker
  },
  props: {
    /**
    * WFS/WMS parameters, such as the destination URL and projection for geometries.
    */
    services: { type: Object, required: false }
  },
  data () {
    return {
      has_kennzahlen: false,
      einsparungProzent: 0,
      einsparungAbsolut: 0,
      einsparung: null,
      renewablesLegible: null,
      currentLegible: null,
      futureLegible: null,
      energietraegerDict: dict,
      pieChartDataSource: null,
      city_name: null,
      total: null,
      featureProps: [],
      moduleName: 'analysetool',
      /**
      * The active controller for WMS / WFS requests.
      */
      heatDataController: undefined,
      /**
      * Controllers for WMS / WFS requests.
      */
      DataControllers: [],
      /**
      * A geometry containing the selected area on map.
      */
      selectedArea: undefined,
      /*
      * A geometry containing the recently requested area.
      * This has to be stored separetely from selectedArea,
      * in case of a selection reset.
      */
      requestedArea: undefined,
      /**
      * Object containing the computed heatData.
      */
      heatData: [],
      /**
      * Computing state.
      */
      loading: false,
      /**
      * List of errors / warnings
      */
      alertTypes: {
        requestError: 'error',
        noDataWarning: 'warning',
        noLayerWarning: 'warning'
      },
      /**
      * Binding for visibility of the alert box.
      */
      alertVisible: false,
      /**
      * Currently displayed error / warning message.
      */
      alertCode: null,
      /**
      * Cancel token source to cancel pending requests.
      */
      pendingRequestsCancelSrc: null,
      /**
      * Chart group ID for connecting charts.
      */
      chartGroup: 'analysetool-charts',
      /**
      * Current layers
      */
      activeLayer: null,
      /**
      * Future scenarios for areaPicker and BarChart
      */
      scenarios: [{ id: 1, name: 'moderat' }, { id: 2, name: 'ambitioniert' }],
      selectedScenarioProp: 'moderat'
    }
  },
  methods: {
    /**
    * This function is executed, after the map is bound (see mixins/Mapable).
    * Initialize the heatData potential module.
    */
    onMapBound () {
      this.createControllers();
    },
    /**
    * Loads module specific layers when the module is opened / closed.
    * @param  {boolean} visible New visibility state
    */
    show (visible) {
      if (visible) {
        // console.log('show');
      } else {
        // console.log('hide');
      }
    },
    /**
    * Create controllers for WMS / WFS requests.
    */
    createControllers () {
      this.DataControllers = [
        new DataController(this.map, this.services.heatAnalysis)
      ];
      this.heatDataController = this.DataControllers[0];
    },

    parseSelectedFeatures (features) {
      if (!features) {
        return;
      }
      const energieverbrauchFeats = JSON.parse(features[0].get('energieverbrauch_json'));
      const renewablesFeats = JSON.parse(features[0].get('ee_jsondata'));
      const currentFeats = JSON.parse(features[0].get('kz_current_jsondata'));
      const futureFeats = JSON.parse(features[0].get('kz_2045_jsondata'));
      this.city_name = features[0].get('city_name');

      this.has_kennzahlen = features[0].get('bl_kennzahlen');

      this.renewablesLegible = this.replaceKeys(renewablesFeats);
      this.currentLegible = this.replaceKeys(currentFeats);
      this.futureLegible = this.replaceKeys(futureFeats);
      this.einsparung = this.parseVerbrauch(energieverbrauchFeats);
      this.shares = this.parseShares(futureFeats);
      this.total = renewablesFeats.gesamt;
    },
    replaceKeys (data) {
      const replacedData = {};

      for (const key in data) {
        const newKey = this.energietraegerDict[key] || key;
        replacedData[newKey] = data[key];
      }
      delete replacedData.gesamt;

      const filtered = Object.fromEntries(
        Object.entries(replacedData).filter(([key, value]) => value >= 1)
      );
      return filtered;
    },
    parseVerbrauch (data) {
      if (!data.energieeinsparung_absolut) return;
      this.einsparungAbsolut = data.energieeinsparung_absolut;
      this.einsparungProzent = data.energieeinsparung_prozent;
      return data;
    },
    parseShares (data) {
      this.shareWasserstoff = Math.round(((data.wasserstoff + data.wasserstoffderivate_insb_synthetisches_methan) / data.gesamt) * 100);
      this.shareBiogen = Math.round(((data.biogener_abfall + data.biomethan + data.deponiegas + data.klargas + data.feste_biomasse + data.flussige_biomasse + data.gasformige_biomasse_insb_biogas) / data.gesamt) * 100);
    }
  },
  computed: {
    renewablePieData () {
      return Object.entries(this.renewablesLegible).map(([key, value]) => ({
        name: key,
        value
      }));
    },
    currentPieData () {
      return Object.entries(this.currentLegible).map(([key, value]) => ({
        name: key,
        value
      }));
    },
    futurePieData () {
      return Object.entries(this.futureLegible).map(([key, value]) => ({
        name: key,
        value
      }));
    },
    /**
    * Return a localized error / warning message associated with the
    * current error code.
    */
    alertMessage () {
      return this.alertVisible
        ? this.$t(`analysetool.alert.${this.alertCode}`)
        : '';
    },
    /**
    * Return the type of alert associated with the current error code.
    */
    alertType () {
      return this.alertTypes[this.alertCode];
    }
  },
  watch: {
    /**
    * Request the data after an area selection has been completed.
    */
    selectedArea () {
      if (this.selectedArea) {
        this.requestedArea = this.selectedArea;
        this.requestData();
      }
    },
    /**
    * Watch for an alert code to be set to display an alert message.
    */
    alertCode () {
      this.alertVisible = !!this.alertCode;
    },
    /**
    * If the user dismisses an alert, reset the alert code,
    * so it can be displayed on the next occasion again.
    */
    alertVisible () {
      if (!this.alertVisible) {
        this.alertCode = null;
      }
    },
    /**
    * Watch for locale changes.
    */
    '$i18n.locale': function () {
    }
  }
}
</script>
